import { Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import PageNotFound from "./routes/PageNotFound";
import { ProtectedRoutes, routes } from "./routes";
import ProtectedRoute from "./routes/ProtectedRoute";
import "./App.css";
import { Layout } from "./components/layout";
import { Loader } from "./icons";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="flex flex-1 h-full justify-center items-center">
              <Loader height={64} width={64} />
            </div>
          }
        >
          <Routes>
            <Route>
              {routes.map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.component}
                  />
                );
              })}
            </Route>
            <Route
              element={
                <Layout>
                  <Outlet type="private" />
                </Layout>
              }
            >
              {ProtectedRoutes.map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={<ProtectedRoute component={route.component} />}
                  />
                );
              })}
            </Route>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
